/**
 * Maps UI filter state to snake_case analytics query params.
 * Multi-select values are passed as arrays (axios serializes them as repeated params).
 */
export const buildMisQueryParams = (filters = {}) => {
  const params = {};

  if (filters.startDate) {
    params.start_date = filters.startDate;
  }
  if (filters.endDate) {
    params.end_date = filters.endDate;
  }
  if (filters.businessProfileKeys?.length) {
    params.business_profile_keys = filters.businessProfileKeys;
  }
  if (filters.customerPartyKeys?.length) {
    params.customer_party_keys = filters.customerPartyKeys;
  }
  if (filters.documentKinds?.length) {
    params.document_kinds = filters.documentKinds;
  }
  if (filters.statuses?.length) {
    params.statuses = filters.statuses;
  }
  if (filters.vatCategoryCodes?.length) {
    params.vat_category_codes = filters.vatCategoryCodes;
  }

  return params;
};
